"use client";

import React, { ReactNode } from "react";
import { Box, Grid, IconButton, Card, CardMedia } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import moreMusic from "../assets/moreMusic.jpg";
import heartTunes from "../assets/heartTunes.jpg";

interface DashboardLayoutProps {
  children: ReactNode;
}

const SidebarLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <Grid container spacing={2} sx={{ px: 12, pt: 7 }}>
      {/* Left Sidebar */}
      <Grid size={3}>
        <Box
          sx={{
            position: "relative",
            background: "#000",
            height: "100vh",
            px: 2,
            py: 4,
          }}
        >
          <Swiper
            modules={[Navigation, Autoplay]}
            slidesPerView={1}
            spaceBetween={20}
            navigation={{
              nextEl: ".next-sidebar",
              prevEl: ".prev-sidebar",
            }}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            loop
            style={{ overflow: "hidden" }}
          >
            <SwiperSlide>
              <Card sx={{ overflow: "hidden", objectFit: "cover" }}>
                <CardMedia
                  component="img"
                  sx={{ objectFit: "contain" }}
                  image={moreMusic}
                  alt="Slide 1"
                />
              </Card>
            </SwiperSlide>

            <SwiperSlide>
              <Card sx={{ overflow: "hidden" }}>
                <CardMedia component="img" image={heartTunes} alt="Slide 2" />
              </Card>
            </SwiperSlide>
          </Swiper>

          {/* Swiper Navigation Buttons */}
          <IconButton
            className="prev-sidebar"
            sx={{
              position: "absolute",
              top: "30%",
              left: "10px",
              transform: "translateY(-50%)",
              color: "#fff",
              opacity: 0.8,
              transition: "all 0.3s ease",
              filter: "drop-shadow(0 0 3px rgba(0,0,0,0.7))",
              "&:hover": {
                transform: "translateY(-50%) scale(1.2)",
                opacity: 1,
                filter: "drop-shadow(0 0 8px rgba(0,176,255,0.9))",
              },
              zIndex: 10,
            }}
          >
            <ArrowForwardIosIcon
              sx={{
                transform: "rotate(180deg)",
                fontSize: 28,
                textShadow: "0px 0px 5px rgba(0,0,0,0.8)",
              }}
            />
          </IconButton>

          <IconButton
            className="next-sidebar"
            sx={{
              position: "absolute",
              top: "30%",
              right: "10px",
              transform: "translateY(-50%)",
              color: "#fff",
              opacity: 0.8,
              transition: "all 0.3s ease",
              filter: "drop-shadow(0 0 3px rgba(0,0,0,0.7))",
              "&:hover": {
                transform: "translateY(-50%) scale(1.2)",
                opacity: 1,
                filter: "drop-shadow(0 0 8px rgba(0,176,255,0.9))",
              },
              zIndex: 10,
            }}
          >
            <ArrowForwardIosIcon
              sx={{
                fontSize: 28,
                textShadow: "0px 0px 5px rgba(0,0,0,0.8)",
              }}
            />
          </IconButton>
        </Box>
      </Grid>
      <Grid size={9}>{children}</Grid>
    </Grid>
  );
};

export default SidebarLayout;
